import { ILLUSTRATION_RATIO, illustrationUrl, type IllustrationId } from './art.js';
import styles from './Illustration.module.css';
import { cx } from './color.js';

export interface IllustrationProps {
  id: IllustrationId;
  /** Breedte in px; de hoogte volgt 4:3. */
  width?: number;
  /** Alleen als de illustratie zelf informatie draagt; meestal decoratief (alt=""). */
  alt?: string;
  class?: string | undefined;
}

/**
 * Eigen illustratie als statisch bestand (<img> met vaste maten: geen layout-verschuiving, niet
 * in de JS-bundle). Kiosk en webapp serveren ze onder /art/illus/.
 */
export function Illustration({ id, width = 240, alt = '', class: cls }: IllustrationProps) {
  return (
    <img
      class={cx(styles.illustration, cls)}
      src={illustrationUrl(id)}
      width={width}
      height={Math.round(width * ILLUSTRATION_RATIO)}
      alt={alt}
      draggable={false}
    />
  );
}
